<template>
  <section class="viewsrhqyPriceManage_nowPrice p-4 space-y-2">
    <viewTitle title="业务管理 / 价格管理" :showReturn="false" />
    <div class="space-x-2">
      <el-button v-has="['c-price-record-import']" type="primary" @click="onImport" size="small">导入Execl</el-button>
      <el-button v-has="['c-price-record-export']" type="default" @click="onExport" size="small">导出Execl</el-button>
      <el-button v-has="['c-price-record-delete']" type="danger" @click="onDelete" size="small">删 除</el-button>
    </div>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="基地" v-if="baseInfo.is_main_com === 1">
        <el-select class="w-40" clearable v-model="queryParam.delivery_com_id">
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="物料号">
        <el-input
          clearable
          v-model="queryParam.material_code"
          placeholder="请输入物料号"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="物料描述">
        <el-input
          clearable
          v-model="queryParam.material_desc"
          placeholder="请输入物料描述"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="运输方式">
        <el-input
          clearable
          v-model="queryParam.shipping_type"
          placeholder="请输入运输方式"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="执行日期">
        <el-date-picker
          class="!w-96"
          style="margin-bottom: 10px;"
          v-model="timeRange"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="执行开始日期"
          end-placeholder="执行结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="refreshData" size="small"
        >刷新数据
      </el-button>
      <el-button @click="onReset" size="small"
        >重置
      </el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :isSelection="true"
      :selection.sync="rowKeySelection"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="execute_time" slot-scope="{ row }">
        {{ row.execute_time | timeFormat('YYYY-MM-DD') }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link v-has="['c-price-record-update']" @click="onEdit(row)" label="修改" type="primary"></c-link>
          <c-link v-has="['c-price-record-delete']" @click="onDelete(row, 1)" label="删除" type="danger"></c-link>
        </div>
      </template>
    </c-table>
    <c-import v-bind="importOptions" :show.sync="showImport" @finish="refreshData">
      <span slot="desc">
        <span>
          3、仅支持模板信息格式，请勿填写其他数据内容
        </span>
        <br />
      </span>
    </c-import>
    <edit-price ref="edit" @ok="refreshData"/>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout.js";
import editPrice from "./components/editPrice.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showImport: false,
      importOptions: {
        downloadDemoName: "价格管理导入模板",
        templateUrl: "/api/queue/admin/download_template?file_name=import_price.xlsx",
        uploadUrl: "/api/media/upload",
        importUrl: "/api/queue/admin/import_price",
        progressUrl: "/api/queue/admin/get_imexport_progress",
        otherParams: {},
      },
      columns: [
        {
          label: "基地",
          prop: "delivery_com_name"
        },
        { label: "物料号", prop: "material_code" },
        { label: "物料描述", prop: "material_desc" },
        { label: "运输方式", prop: "shipping_type" },
        { label: "分区", prop: "subarea" },
        { label: "地区", prop: "region" },
        { label: "税率", prop: "tax_rate" },
        { label: "含税价格（元/绝干吨）", prop: "total_price" },
        { label: "执行日期", prop: "execute_time" },
        { label: "备注", prop: "remark" },
        { label: "操作", prop: "action" }
      ],
      deleteConfig: {
        title: "删除", // 标题
        content: "确认删除？删除后数据将不可恢复！",
        url: "/api/queue/admin/delete_price",
        paramsKey: "ids", // 提交参数的key
        paramsType: 'array'
      },
      fetchDataEvent: params => {
        const { begin_time, end_time, ...data } = params;
        return this.$common.http({
          url: "/api/queue/admin/query_price",
          data: {
            ...data,
            execute_begin_time: begin_time,
            execute_end_time: end_time
          }
        });
      },
      exportDataEvent: params => {
        const { begin_time, end_time, ...data } = params;
        return this.$common.http({
          url: "/api/queue/admin/export_price",
          data: {
            ...data,
            execute_begin_time: begin_time,
            execute_end_time: end_time
          },
          noLoading: true
        })
      }
    };
  },

  computed: {
    ...mapGetters(["baseInfo"])
  },

  watch: {},

  components: {
    editPrice
  },

  mixins: [initListMinxin, mixinTableLyout],

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    onImport() {
      this.showImport = true;
    },
    onEdit(row) {
      this.$refs.edit.onOpen(row);
    }
  }
};
</script>
<style lang="less" scoped>
.viewsrhqyPriceManage_nowPrice {
}
</style>
<style lang="less">
.viewsrhqyPriceManage_nowPrice {
}
</style>
